import { render, staticRenderFns } from "./sanity-blocks.global.vue?vue&type=template&id=5504bdc8&"
import script from "./sanity-blocks.global.vue?vue&type=script&lang=js&"
export * from "./sanity-blocks.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports